import { lazy, Suspense, useContext } from 'react'
import type { ComponentProps } from 'react'
import type TokenSocialLinksEditorInner from '@/components/TokenSocialLinksEditorInner'
import { WalletReadyContext } from '@/lib/walletContext'

/**
 * Client-only boundary for the creator links editor.
 *
 * The inner editor uses wagmi `useWalletClient` so Save can open the connected
 * AppKit wallet sign modal. Loading it lazily keeps the Node prerender path
 * free of WalletConnect `require("ws")`.
 *
 * DO NOT convert this back into a static import.
 */
const TokenSocialLinksEditorInnerLazy = lazy(() => import('@/components/TokenSocialLinksEditorInner'))

type TokenSocialLinksEditorProps = ComponentProps<typeof TokenSocialLinksEditorInner>

function TokenSocialLinksEditor(props: TokenSocialLinksEditorProps) {
  const ready = useContext(WalletReadyContext)
  if (!ready)
    return null

  return (
    <Suspense fallback={null}>
      <TokenSocialLinksEditorInnerLazy {...props} />
    </Suspense>
  )
}

export default TokenSocialLinksEditor
